import React from "react";
import { getHoleStyles } from "./ScorecardSummaryHeaderHoleStyles";

function ScorecardSummaryTableStickyHolesHeaderRow({ hole, index, maxHole }) {
  const { color, background } = getHoleStyles(index, maxHole);

  return (
    <th
      key={index}
      style={{
        color,
        background,
      }}
    >
      {hole}
    </th>
  );
}

export default ScorecardSummaryTableStickyHolesHeaderRow;
